import React from 'react';
import { withRouter } from 'react-router-dom';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppMeterGroupsService from '../../AppMeterGroupsService';

//hooks
import { useRouter } from '../../../../shared/hooks/useRouter';

//global component
import ModalButton from '../../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
} from '../../../../SharedStyles';

const RedirectChargers = (props) => {
  const { meterGroup } = props;
  const { strings } = AppMeterGroupsService;
  const router = useRouter();

  const closeModal = () => {
    props.handleCloseModal();
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    router.history.push(`/chargers?meterGroupId=${meterGroup.meterGroupId}`);
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.chargerTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0'>
            <p>{strings.chargerContent}</p>
          </ModalItemStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={handleSaveInfo}
          buttonText={strings.ok}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default withRouter(RedirectChargers);
